import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import util from 'Utils/commonUtil';

// Components
import {Grid, Checkbox} from '@material-ui/core';
import Header from 'Components/common/Header';
import Dialog from 'Components/common/Dialog';
import F1ShoppingCart from 'Components/replenishment/F1ShoppingCart';
import BasicButton from 'Components/common/BasicButton';
import LoadingIcon from 'Components/icons/LoadingIcon';
import {loadLanguage} from 'Utils/jwtUtil';
import BasicTextArea from 'Components/common/BasicTextArea';
import BasicInput from 'Components/common/BasicInput';

// Actions
import {T} from 'Actions/translate';
import {setAdminData, setUserData} from 'Actions/localData';
import {
    getSCInventroyDetails,
    getF1CartCount,
    AddF1Product,
    BatchAddF1Product,
    QueryF1Cart,
    DeleteF1Cart,
    sumbitF1Quantity,
    submitF1Order,
    getInventoryDetails,
    getSysDict,
    addSelectedLotCache,
    getF1CartSelectedLotList,
    // checkSku,
    // pushAddCart
} from 'Actions/replenishment';
import {openNotification} from 'Actions/notification';

class ReplenishmentCart extends Component {
    state = {
        listLoaded: true,
        checkAll: false,
        selectedProduct: [],
        defaultCheck: false,
        checkNum: 0,
        selectedItem: null,
        deleteItemDialogOpened: false,
        initial: true,
        pageLoading: false,
        inventoryDetailsLoading: false,
        inventoryDetailsOpened: false,
        inventoryCheckAll: false,
        singleCheck: false,
        selectedInventorySku: [],
        skuInventoryData: [],
        currentCartId: 0,
        allSkuLotInformation: [],
        comments: '',
        selectedSkuLotReqs: [],
        currentSupplyId: 0,
        currentSku: '',
        confirmBtn: false,
        allSelectedLotList: [],
        submitSkuToF1CartMassage: [],
        submitSkuToF1CartDialogOpened: false,
    };

    componentWillMount() {}

    componentDidMount() {
        const {localData} = this.props;
        this.getF1Cart();
        this.props.setUserData({
            data: {
                email: localData.customerEmail,
                shipToNum: localData.shipToNum,
                isProxyProcess: false,
                type: localData.roleType,
                name: localData.name,
            },
        });
        if (localStorage.getItem('SkuLotInformation')) {
            localStorage.setItem('SkuLotInformation', []);
        }

        let dictType = 'sku_lot_reqs';
        this.props.getSysDict(dictType).then((res) => {
            if (this.props.timeRangeOptions.length > 0) {
                const currentSelectedSkuLotReqs = JSON.parse(
                    JSON.stringify(this.props.timeRangeOptions),
                );
                this.setState(
                    {
                        selectedSkuLotReqs: currentSelectedSkuLotReqs,
                    },
                    () => {
                        this.state.selectedSkuLotReqs.forEach(
                            (timeItem, timeIndex) => {
                                timeItem.checked = false;
                            },
                        );
                    },
                );
            }
        });
    }
    componentDidUpdate() {
        const dialogMask = ReactDOM.findDOMNode(
            document.getElementsByClassName('dialog-mask')[0],
        );
        if (dialogMask !== null && this.state.inventoryDetailsOpened) {
            const dialogWrap = dialogMask.children[0];
            const dialogMaskHeight = dialogMask.clientHeight;
            const dialogWrapOffsetHeight = dialogWrap.offsetHeight;
            if (document.getElementById('skuInventoryUl') !== null) {
                if (dialogMaskHeight !== 0 && dialogWrapOffsetHeight !== 0) {
                    if (dialogWrapOffsetHeight > dialogMaskHeight) {
                        document.getElementsByClassName(
                            'dialog-warp',
                        )[0].style.top = '0%';
                        document.getElementsByClassName(
                            'dialog-warp',
                        )[0].style.WebkitTransform = 'translateX(-50%)';
                    } else {
                        document.getElementsByClassName(
                            'dialog-warp',
                        )[0].style.top = '50%';
                        document.getElementsByClassName(
                            'dialog-warp',
                        )[0].style.WebkitTransform = 'translate(-50%, -50%)';
                    }
                } else {
                    if (
                        this.props.skuInventoryDetails.length > 0 &&
                        this.state.skuInventoryData ===
                            this.props.skuInventoryDetails
                    ) {
                        if (this.props.skuInventoryDetails.length <= 5) {
                            document.getElementsByClassName(
                                'dialog-warp',
                            )[0].style.top = '50%';
                            document.getElementsByClassName(
                                'dialog-warp',
                            )[0].style.WebkitTransform =
                                'translate(-50%, -50%)';
                        } else {
                            document.getElementsByClassName(
                                'dialog-warp',
                            )[0].style.top = '0%';
                            document.getElementsByClassName(
                                'dialog-warp',
                            )[0].style.WebkitTransform = 'translateX(-50%)';
                        }
                    }
                }
            }
        }
    }

    handleCheck = (event) => {
        const {f1CartList} = this.props;
        let selectedProductArray = [];

        if (event.target.checked) {
            f1CartList &&
                f1CartList.forEach((item) => {
                    selectedProductArray.push(item.id);
                });
        } else {
            selectedProductArray = [];
        }

        this.setState({
            checkAll: event.target.checked,
            defaultCheck: event.target.checked,
            checkNum: event.target.checked ? this.getTotal() : 0,
            selectedProduct: selectedProductArray,
        });
    };

    handleInventoryCheck = (event) => {
        const {skuInventoryDetails} = this.props;
        let selectedInventorySkuArray = [];
        let isInitId = false;
        if (event.target.checked) {
            skuInventoryDetails &&
                skuInventoryDetails.forEach((item) => {
                    selectedInventorySkuArray.push(item);
                });
            this.controlInventoryCheck(
                this.state.skuInventoryData,
                isInitId,
                event.target.checked,
            );
        } else {
            selectedInventorySkuArray = [];
            this.controlInventoryCheck(this.state.skuInventoryData, isInitId);
        }
        this.setState({
            inventoryCheckAll: event.target.checked,
            selectedInventorySku: selectedInventorySkuArray,
        });
    };

    handleSingleCheck = (flg, num, cartId) => {
        let checkNum = this.state.checkNum;
        let selectedProduct = this.state.selectedProduct;

        this.setState({
            defaultCheck: this.state.checkAll,
        });
        if (flg) {
            checkNum += num;
            selectedProduct.push(cartId);
        } else {
            checkNum -= num;
            selectedProduct.splice(selectedProduct.indexOf(cartId), 1);
        }

        this.setState({
            checkNum: checkNum,
            selectedProduct: selectedProduct,
        });
    };

    inventorySingleHandleCheck = (inventoryItem, event) => {
        let selectedInventorySkuArray = this.state.selectedInventorySku;
        let isCheckedFlag = event.target.checked;
        let isAddInventory = true;
        let currentSkuInventoryData = this.state.skuInventoryData;

        if (isCheckedFlag) {
            selectedInventorySkuArray.forEach((item) => {
                if (
                    item.availableInventory ===
                        inventoryItem.availableInventory &&
                    item.availableQuantity ===
                        inventoryItem.availableQuantity &&
                    item.branch === inventoryItem.branch &&
                    item.branchDesc === inventoryItem.branchDesc &&
                    item.ddnsaDate === inventoryItem.ddnsaDate &&
                    item.dnsaDate === inventoryItem.dnsaDate &&
                    item.location === inventoryItem.location &&
                    item.lot === inventoryItem.lot &&
                    item.lotExpirationDate ===
                        inventoryItem.lotExpirationDate &&
                    item.sku === inventoryItem.sku &&
                    item.type === inventoryItem.type
                ) {
                    isAddInventory = false;
                }
            });
            if (isAddInventory) {
                inventoryItem.currentCartId = this.state.currentCartId;
                selectedInventorySkuArray.push(inventoryItem);

                if (currentSkuInventoryData.length > 0) {
                    currentSkuInventoryData.forEach((itemData, itemIndex) => {
                        if (
                            itemData.availableInventory ===
                                inventoryItem.availableInventory &&
                            itemData.availableQuantity ===
                                inventoryItem.availableQuantity &&
                            itemData.branch === inventoryItem.branch &&
                            itemData.branchDesc === inventoryItem.branchDesc &&
                            itemData.ddnsaDate === inventoryItem.ddnsaDate &&
                            itemData.dnsaDate === inventoryItem.dnsaDate &&
                            itemData.location === inventoryItem.location &&
                            itemData.lot === inventoryItem.lot &&
                            itemData.lotExpirationDate ===
                                inventoryItem.lotExpirationDate &&
                            itemData.sku === inventoryItem.sku &&
                            itemData.type === inventoryItem.type
                        ) {
                            itemData.checked = true;
                        }
                    });
                    let tempSelectedSkuData = [];
                    currentSkuInventoryData.forEach((skuData, skuIndex) => {
                        if (skuData.checked) {
                            tempSelectedSkuData.push(skuData);
                        }
                    });
                    selectedInventorySkuArray = tempSelectedSkuData;
                }
            }
        } else {
            currentSkuInventoryData.length > 0 &&
                currentSkuInventoryData.forEach((itemData, itemIndex) => {
                    if (
                        itemData.availableInventory ===
                            inventoryItem.availableInventory &&
                        itemData.availableQuantity ===
                            inventoryItem.availableQuantity &&
                        itemData.branch === inventoryItem.branch &&
                        itemData.branchDesc === inventoryItem.branchDesc &&
                        itemData.ddnsaDate === inventoryItem.ddnsaDate &&
                        itemData.dnsaDate === inventoryItem.dnsaDate &&
                        itemData.location === inventoryItem.location &&
                        itemData.lot === inventoryItem.lot &&
                        itemData.lotExpirationDate ===
                            inventoryItem.lotExpirationDate &&
                        itemData.sku === inventoryItem.sku &&
                        itemData.type === inventoryItem.type
                    ) {
                        itemData.checked = false;
                    }
                });
            if (this.state.inventoryCheckAll) {
                this.setState({
                    inventoryCheckAll: false,
                });
            }

            let currentSelectedProduct = currentSkuInventoryData.filter(
                (item) => item.checked !== false,
            );
            selectedInventorySkuArray = currentSelectedProduct;
        }
        this.setState({
            selectedInventorySku: selectedInventorySkuArray,
            skuInventoryData: currentSkuInventoryData,
        });
    };

    timeRangeSingleHandleCheck = (timeRangeItem, event) => {
        let isCheckedFlag = event.target.checked;
        let checkedSelectedSkuLotReqs = this.state.selectedSkuLotReqs;
        checkedSelectedSkuLotReqs.length > 0 &&
            checkedSelectedSkuLotReqs.forEach((timeItem, timeIndex) => {
                if (timeItem.value === timeRangeItem.value) {
                    timeItem.checked = isCheckedFlag;
                }
            });

        this.setState({
            selectedSkuLotReqs: checkedSelectedSkuLotReqs,
        });
    };

    getTotal = () => {
        const {f1CartList} = this.props;
        let total = 0;

        f1CartList &&
            f1CartList.forEach((item) => {
                total += item.quantity;
            });

        return total;
    };

    changeNum = (f1CartInfo, num) => {
        if (num) {
            this.props.sumbitF1Quantity({
                id: f1CartInfo.id,
                quantity: num,
            });
        }
    };

    replenish = () => {
        const {selectedProduct} = this.state;
        const {comments} = this.state;
        let params = {};
        let carts = [];

        // console.log(this.getCacheSkuOfLotInfor());
        // console.log(this.props.f1CartList);

        let defaultCacheData = this.getCacheSkuOfLotInfor();
        if (defaultCacheData.length < 0) {
            selectedProduct.length > 0 &&
                selectedProduct.forEach((cartItem, cartIndex) => {
                    let currentSelectP = {
                        cartId: cartItem,
                        skuLotInfos: [],
                        skuLotReqs: [],
                    };
                    carts.push(currentSelectP);
                });
        } else {
            let defaultLotsArry = [];
            let isCheckedAll = false;
            if (
                this.props.f1CartList.length > 0 &&
                this.props.f1CartList.length === defaultCacheData.length
            ) {
                isCheckedAll = true;
            }
            this.props.f1CartList.length > 0 &&
                this.props.f1CartList.forEach((f1CatrItem, f1CartIndex) => {
                    defaultCacheData.forEach((defaultItem, defaultIndex) => {
                        if (f1CatrItem.sku === defaultItem.sku) {
                            defaultLotsArry.push({
                                cartId: f1CatrItem.id,
                                inventoryCheckAll: isCheckedAll,
                                skuLotInfos:
                                    defaultItem.f1SkuCacheModel.skuLotInfoList,
                                skuLotReqs:
                                    defaultItem.f1SkuCacheModel.skuLotReqs,
                            });
                        }
                    });
                });
            let defaultCheckedSku = [];
            let defaultNoCheckedSku = [];
            if (defaultLotsArry.length > 0) {
                defaultCheckedSku = defaultLotsArry.filter((obj) =>
                    selectedProduct.some((obj1) => obj1 === obj.cartId),
                );

                defaultNoCheckedSku = selectedProduct.filter(
                    (obj) =>
                        !defaultLotsArry.some((obj1) => obj1.cartId === obj),
                );

                if (defaultNoCheckedSku.length > 0) {
                    defaultNoCheckedSku.forEach(
                        (defaultNoCheckedCartId, noCheckedIndex) => {
                            defaultCheckedSku.push({
                                cartId: defaultNoCheckedCartId,
                                skuLotInfos: [],
                            });
                        },
                    );
                }

                carts = defaultCheckedSku;
            } else {
                let noSelectedInfor = this.noSelectedLotInfor(selectedProduct);

                // console.log(noSelectedInfor);

                carts = noSelectedInfor;
            }
        }

        // console.log(carts);

        params['carts'] = carts;
        params['comments'] = comments || '';

        if (selectedProduct.length > 0) {
            this.setState({
                pageLoading: true,
            });

            this.props
                .submitF1Order(params, this.orderSuccess)
                .then((res) => {
                    this.setState({pageLoading: false});
                    this.disableOverFlow(false);

                    localStorage.setItem('SkuLotInformation', []);
                })
                .catch((err) => {
                    if (err.status === 'invalid_cartId') {
                        this.props.openNotification(
                            T('notification_invalid_cartId'),
                            'danger',
                        );
                    } else if (err.status === 'Black_Sku') {
                        let formatMessageOneData = this.formatBlackList(
                            err.message,
                        );
                        this.setState({
                            submitSkuToF1CartDialogOpened: true,
                            submitSkuToF1CartMassage: formatMessageOneData,
                        });
                    }
                    this.setState({pageLoading: false});
                    this.disableOverFlow(false);
                });
        } else {
            this.props.openNotification(
                T('notification_please_select_the_replenishment_item'),
                'danger',
            );
        }
    };

    formatBlackList = (message) => {
        let messageArry = message.length > 0 && message.split('\r\n');
        let newMessageArry = [];
        messageArry.length > 0 &&
            messageArry.forEach((messageItem) => {
                if (messageItem) {
                    let messageObj = {};
                    let itemArry = messageItem.split(',');

                    itemArry.length > 0 &&
                        itemArry.forEach((item, index) => {
                            if (index === 0) {
                                messageObj.sku = item.substring('4');
                            } else if (index === 1) {
                                messageObj.reason = item.substring('7');
                            }
                        });
                    newMessageArry.push(messageObj);
                }
            });

        return newMessageArry;
    };

    noSelectedLotInfor = (selectedProduct) => {
        let tempNoSelectedLotArry = [];
        selectedProduct.length > 0 &&
            selectedProduct.forEach((cartItem, cartIndex) => {
                let currentSelectP = {
                    cartId: cartItem,
                    skuLotInfos: [],
                    skuLotReqs: [],
                };
                tempNoSelectedLotArry.push(currentSelectP);
            });
        return tempNoSelectedLotArry;
    };

    getCacheSkuOfLotInfor = () => {
        let {allSelectedLotList} = this.state;
        let defaultSelectLot = [];
        allSelectedLotList.length > 0 &&
            allSelectedLotList.forEach((lotItem, lotIndex) => {
                if (lotItem.isHitCache) {
                    defaultSelectLot.push(lotItem);
                }
            });
        return defaultSelectLot;
    };

    hideloading = () => {
        this.setState({
            listLoaded: false,
        });
    };

    deleteF1Item = (f1CartInfo) => {
        const {localData} = this.props;

        this.props
            .DeleteF1Cart(
                {
                    ids: [f1CartInfo.id],
                    supplyCenterId: localData.defaultScId,
                },
                this.getF1Cart,
            )
            .then((res) => {
                if (res.status === 'success') {
                    let checkedProduct = this.state.selectedProduct;
                    let currentSelectedProduct = [];
                    if (checkedProduct.length > 0) {
                        currentSelectedProduct = checkedProduct.filter(
                            (item) => item !== f1CartInfo.id,
                        );
                    }
                    // let currentSelectedProduct = checkedProduct.length > 0 && checkedProduct.filter(item => item != f1CartInfo.id );
                    this.setState({
                        selectedProduct: currentSelectedProduct,
                    });
                }
                this.dialogDidClose('deleteItemDialogOpened');
            });
    };

    batchDeletion = () => {
        const {localData} = this.props;
        if (this.state.selectedProduct.length > 0) {
            this.props
                .DeleteF1Cart(
                    {
                        ids: this.state.selectedProduct,
                        supplyCenterId: localData.defaultScId,
                    },
                    this.getF1Cart,
                )
                .then((res) => {
                    if (res.status === 'success') {
                        this.setState({
                            selectedProduct: [],
                        });
                        this.dialogDidClose('deleteItemDialogOpened');
                    }
                });
        } else {
            this.props.openNotification(
                T('notification_please_select_the_batch_deletion_item'),
                'danger',
            );
        }
    };

    getF1Cart = () => {
        const {localData} = this.props;

        if (localData) {
            this.props
                .QueryF1Cart(
                    {
                        supplyCenterId: localData.defaultScId,
                    },
                    this.hideloading,
                )
                .then((res) => {
                    if (res) {
                        this.state.initial &&
                            this.handleCheck({
                                target: {
                                    checked: true,
                                },
                            });
                        if (res.status === 'success' && res.data.length > 0) {
                            this.getF1CartSelectedLotListHandle(res.data);
                        }
                        this.setState({
                            initial: false,
                        });
                    }
                });
        }
    };

    getF1CartSelectedLotListHandle = (f1CartSelectedLotList) => {
        const {localData} = this.props;
        let skuArrs = [];
        f1CartSelectedLotList.forEach((item, index) => {
            skuArrs.push(item.sku);
        });

        this.props
            .getF1CartSelectedLotList({
                supplyCenterId: localData.defaultScId,
                skus: skuArrs,
            })
            .then((res) => {
                if (res && res.status === 'success') {
                    this.setState({
                        allSelectedLotList: res.data,
                    });
                }
            });
    };

    orderSuccess = (res) => {
        if (res.status === 'success') {
            const localData = {...this.props.localData};

            localData.isProxyProcess = false;

            this.props.setAdminData({data: localData}).then(() => {
                this.props.history.push('/orderSuccess');
            });
        } else {
            this.props.openNotification(T('submitOrderFailure'), 'danger');
        }
    };

    chooseItem = (f1CartInfo) => {
        this.setState({selectedItem: f1CartInfo});
        this.openDialog('deleteItemDialogOpened');
    };

    disableOverFlow = (flg) => {
        let body = document.getElementsByTagName('body')[0];

        if (flg) {
            body.style.overflow = 'hidden';
        } else {
            body.style.overflow = 'visible';
        }
    };

    getCurrentSelectedLotInfor = (f1CartSelectedLotsInfor, cartId) => {
        let currentInventorySkuChecked = [];
        if (!localStorage.getItem('SkuLotInformation')) {
            currentInventorySkuChecked.push({
                cartId: cartId,
                inventoryCheckAll: false,
                skuLotInfos:
                    f1CartSelectedLotsInfor.f1SkuCacheModel.skuLotInfoList,
                skuLotReqs: f1CartSelectedLotsInfor.f1SkuCacheModel.skuLotReqs,
            });
        } else {
            let isContainSku = false;
            currentInventorySkuChecked = JSON.parse(
                localStorage.getItem('SkuLotInformation'),
            );
            currentInventorySkuChecked.forEach((item) => {
                if (item.cartId === cartId) {
                    isContainSku = true;
                    item.skuLotInfos =
                        f1CartSelectedLotsInfor.f1SkuCacheModel.skuLotInfoList;
                }
            });
            if (!isContainSku) {
                currentInventorySkuChecked.push({
                    cartId: cartId,
                    inventoryCheckAll: false,
                    skuLotInfos:
                        f1CartSelectedLotsInfor.f1SkuCacheModel.skuLotInfoList,
                    skuLotReqs:
                        f1CartSelectedLotsInfor.f1SkuCacheModel.skuLotReqs,
                });
            }
        }
        return currentInventorySkuChecked;
    };

    inventoryDetails = (sku, cartId, f1CartInfo, f1CartSelectedLotsInfor) => {
        this.setState({
            inventoryDetailsLoading: true,
            currentSupplyId: f1CartInfo.supplyCenterId,
            currentSku: f1CartInfo.sku,
        });

        this.props
            .getInventoryDetails(sku, this.inventoryDetailsSuccess)
            .then((res) => {
                setTimeout(() => {
                    this.setState({
                        currentCartId: cartId,
                    });
                });

                if (
                    (localStorage.getItem('SkuLotInformation') &&
                        JSON.parse(localStorage.getItem('SkuLotInformation'))
                            .length > 0) ||
                    f1CartSelectedLotsInfor.f1SkuCacheModel.skuLotInfoList
                        .length > 0 ||
                    f1CartSelectedLotsInfor.f1SkuCacheModel.skuLotReqs.length >
                        0
                ) {
                    let currentInventorySkuChecked =
                        this.getCurrentSelectedLotInfor(
                            f1CartSelectedLotsInfor,
                            cartId,
                        );

                    let isContainSku = false;
                    currentInventorySkuChecked.forEach((item) => {
                        if (item.cartId === cartId) {
                            isContainSku = true;
                        }
                    });
                    currentInventorySkuChecked.map((cartItem, cartIndex) => {
                        if (
                            cartItem.cartId === cartId &&
                            cartItem.skuLotInfos.length > 0
                        ) {
                            let isInitId = true;

                            let skuLotReqs = this.getCheckedTimeOptions(
                                cartItem.skuLotReqs,
                            );

                            this.controlInventoryCheck(
                                this.props.skuInventoryDetails,
                                isInitId,
                            );

                            setTimeout(() => {
                                this.setState({
                                    skuInventoryData:
                                        this.props.skuInventoryDetails,
                                    inventoryCheckAll:
                                        cartItem.inventoryCheckAll,
                                    selectedSkuLotReqs: skuLotReqs,
                                });
                            });
                            let currentSkuInventoryData =
                                this.props.skuInventoryDetails;
                            if (cartItem.skuLotInfos.length > 0) {
                                for (
                                    let n = 0;
                                    n < cartItem.skuLotInfos.length;
                                    n++
                                ) {
                                    currentSkuInventoryData.map(
                                        (checkedItem, index) => {
                                            if (
                                                checkedItem.availableInventory ===
                                                    cartItem.skuLotInfos[n]
                                                        .availableInventory &&
                                                checkedItem.availableQuantity ===
                                                    cartItem.skuLotInfos[n]
                                                        .availableQuantity &&
                                                checkedItem.branch ===
                                                    cartItem.skuLotInfos[n]
                                                        .branch &&
                                                checkedItem.branchDesc ===
                                                    cartItem.skuLotInfos[n]
                                                        .branchDesc &&
                                                checkedItem.ddnsaDate ===
                                                    cartItem.skuLotInfos[n]
                                                        .ddnsaDate &&
                                                checkedItem.dnsaDate ===
                                                    cartItem.skuLotInfos[n]
                                                        .dnsaDate &&
                                                checkedItem.location ===
                                                    cartItem.skuLotInfos[n]
                                                        .location &&
                                                checkedItem.lot ===
                                                    cartItem.skuLotInfos[n]
                                                        .lot &&
                                                checkedItem.lotExpirationDate ===
                                                    cartItem.skuLotInfos[n]
                                                        .lotExpirationDate &&
                                                checkedItem.sku ===
                                                    cartItem.skuLotInfos[n]
                                                        .sku &&
                                                checkedItem.type ===
                                                    cartItem.skuLotInfos[n]
                                                        .type &&
                                                f1CartSelectedLotsInfor.isHitCache
                                            ) {
                                                currentSkuInventoryData[
                                                    index
                                                ].checked = true;
                                            } else {
                                                if (
                                                    !currentSkuInventoryData[
                                                        index
                                                    ].checked
                                                ) {
                                                    currentSkuInventoryData[
                                                        index
                                                    ].checked = false;
                                                }
                                            }
                                        },
                                    );
                                }
                                setTimeout(() => {
                                    this.setState({
                                        skuInventoryData:
                                            currentSkuInventoryData,
                                    });
                                });
                            }
                        } else if (
                            cartItem.cartId === cartId &&
                            cartItem.skuLotInfos.length === 0
                        ) {
                            let skuLotReqs = this.getCheckedTimeOptions(
                                cartItem.skuLotReqs,
                            );
                            let isInitId = true;
                            this.controlInventoryCheck(
                                this.props.skuInventoryDetails,
                                isInitId,
                            );
                            setTimeout(() => {
                                this.setState({
                                    selectedSkuLotReqs: skuLotReqs,
                                    skuInventoryData:
                                        this.props.skuInventoryDetails,
                                });
                            });
                        } else {
                            if (!isContainSku) {
                                let isInitId = true;
                                this.controlInventoryCheck(
                                    this.props.skuInventoryDetails,
                                    isInitId,
                                );
                                setTimeout(() => {
                                    this.setState({
                                        inventoryDetailsLoading: false,
                                        inventoryDetailsOpened: true,
                                        skuInventoryData:
                                            this.props.skuInventoryDetails,
                                        currentCartId: cartId,
                                    });
                                });
                            }
                        }
                    });
                } else {
                    let isInitId = true;
                    this.controlInventoryCheck(
                        this.props.skuInventoryDetails,
                        isInitId,
                    );
                    setTimeout(() => {
                        this.setState({
                            inventoryDetailsLoading: false,
                            inventoryDetailsOpened: true,
                            skuInventoryData: this.props.skuInventoryDetails,
                            currentCartId: cartId,
                        });
                    });
                }
            })
            .catch(() => {
                this.setState({
                    inventoryDetailsLoading: false,
                });
            });
    };

    getCheckedTimeOptions = (skuLotReqs) => {
        let checkedSelectedSkuLotReqs = this.state.selectedSkuLotReqs;
        skuLotReqs.length > 0 &&
            skuLotReqs.map((skuLotItem, skuLotIndex) => {
                checkedSelectedSkuLotReqs.length > 0 &&
                    checkedSelectedSkuLotReqs.map((timeItem, timeIndex) => {
                        if (timeItem.key === skuLotItem) {
                            timeItem.checked = true;
                        }
                    });
            });
        return checkedSelectedSkuLotReqs;
    };

    inventoryDetailsSuccess = () => {
        this.setState({
            inventoryDetailsLoading: false,
            inventoryDetailsOpened: true,
            selectedInventorySku: [],
        });
    };

    openDialog = (key) => !this.setState[key] && this.setState({[key]: true});
    dialogDidClose = (key) => {
        if (this.state[key]) {
            if (key === 'inventoryDetailsOpened') {
                let selectedTOption = this.resetSelectSkuLotReqs();
                this.setState({
                    [key]: false,
                    selectedSkuLotReqs: selectedTOption,
                });
            } else {
                this.setState({
                    [key]: false,
                    submitSkuToF1CartMassage: [],
                });
            }
        }
    };
    goBack = () => this.props.history.push('/replenishmentSCDetails');

    dialogDidInventoryClose = (key) => {
        if (this.state[key]) {
            this.setState({[key]: false});
        }
        const currentSelectedInventorySku = this.state.selectedInventorySku;
        const selectedSkuLotReqs = this.state.selectedSkuLotReqs;
        let selectedTimeOptions = [];
        selectedSkuLotReqs.map((optionItem, optionIndex) => {
            if (optionItem.checked) {
                selectedTimeOptions.push(optionItem.key);
            }
        });

        let currentSkuLotInformation = [];

        if (
            localStorage.getItem('SkuLotInformation') &&
            JSON.parse(localStorage.getItem('SkuLotInformation')).length > 0
        ) {
            let currentLocalStorageSku = JSON.parse(
                localStorage.getItem('SkuLotInformation'),
            );
            let isContainSku = false;
            currentLocalStorageSku.forEach((item) => {
                if (item.cartId === this.state.currentCartId) {
                    isContainSku = true;
                }
            });

            if (isContainSku) {
                let currentSkuCheckedLots = [];
                this.state.skuInventoryData.length > 0 &&
                    this.state.skuInventoryData.map(
                        (inventorySkuItem, inventorySkuIndex) => {
                            if (inventorySkuItem.checked) {
                                currentSkuCheckedLots.push(inventorySkuItem);
                            }
                        },
                    );
                if (currentSelectedInventorySku.length > 0) {
                    currentLocalStorageSku.map((localItem, localIndex) => {
                        if (localItem.cartId === this.state.currentCartId) {
                            localItem.skuLotInfos = currentSkuCheckedLots;
                            localItem.skuLotReqs = selectedTimeOptions;
                            localItem.inventoryCheckAll =
                                this.state.inventoryCheckAll;
                        }
                    });
                    localStorage.setItem(
                        'SkuLotInformation',
                        JSON.stringify(currentLocalStorageSku),
                    );
                } else if (
                    currentSelectedInventorySku.length === 0 &&
                    currentLocalStorageSku.length > 0
                ) {
                    currentLocalStorageSku.forEach((localItem, localIndex) => {
                        if (localItem.cartId === this.state.currentCartId) {
                            localItem.skuLotInfos = currentSkuCheckedLots;
                            localItem.skuLotReqs = selectedTimeOptions;
                            localItem.inventoryCheckAll =
                                this.state.inventoryCheckAll;
                        }
                    });
                    localStorage.setItem(
                        'SkuLotInformation',
                        JSON.stringify(currentLocalStorageSku),
                    );
                } else {
                    if (!this.state.inventoryCheckAll) {
                        let allSkuLot = this.state.allSkuLotInformation;
                        let currentSkuLot = [];
                        if (allSkuLot.length > 0) {
                            currentSkuLot = allSkuLot.filter(
                                (item) =>
                                    item.cartId !== this.state.currentCartId,
                            );
                        }
                        this.setState({
                            allSkuLotInformation: currentSkuLot,
                        });

                        let localStorageSku = currentLocalStorageSku.filter(
                            (item) => item.cartId !== this.state.currentCartId,
                        );
                        localStorage.setItem(
                            'SkuLotInformation',
                            JSON.stringify(localStorageSku),
                        );
                    }
                }
            } else {
                this.getCurrentSkuItem(
                    currentSelectedInventorySku,
                    currentSkuLotInformation,
                );

                currentLocalStorageSku.push({
                    cartId: this.state.currentCartId,
                    skuLotInfos: currentSkuLotInformation,
                    skuLotReqs: selectedTimeOptions,
                    inventoryCheckAll: this.state.inventoryCheckAll,
                });
                localStorage.setItem(
                    'SkuLotInformation',
                    JSON.stringify(currentLocalStorageSku),
                );
            }
        } else {
            if (currentSelectedInventorySku.length > 0) {
                this.getCurrentSkuItem(
                    currentSelectedInventorySku,
                    currentSkuLotInformation,
                );

                let skuLotInformation = this.state.allSkuLotInformation;
                skuLotInformation.push({
                    cartId: this.state.currentCartId,
                    skuLotInfos: currentSkuLotInformation,
                    skuLotReqs: selectedTimeOptions,
                    inventoryCheckAll: this.state.inventoryCheckAll,
                });
                localStorage.setItem(
                    'SkuLotInformation',
                    JSON.stringify(skuLotInformation),
                );
            } else {
                let skuLotInformation = this.state.allSkuLotInformation;
                if (skuLotInformation.length > 0) {
                    skuLotInformation.push({
                        cartId: this.state.currentCartId,
                        skuLotInfos: [],
                        skuLotReqs: selectedTimeOptions,
                        inventoryCheckAll: this.state.inventoryCheckAll,
                    });

                    localStorage.setItem(
                        'SkuLotInformation',
                        JSON.stringify(skuLotInformation),
                    );
                } else {
                    let currentSkuLotInformation = [];
                    currentSkuLotInformation.push({
                        cartId: this.state.currentCartId,
                        skuLotInfos: [],
                        skuLotReqs: selectedTimeOptions,
                        inventoryCheckAll: this.state.inventoryCheckAll,
                    });
                    localStorage.setItem(
                        'SkuLotInformation',
                        JSON.stringify(currentSkuLotInformation),
                    );
                }
            }
        }

        let cacheLotInfor = this.getCacheLotInfor();
        if (currentSkuLotInformation.length > 0) {
            //退出F1购物车,重新进入购物车时公司库存的添加的数据
            let tempSkuLotInfor = [];
            // if (cacheLotInfor.f1SkuCacheModel.skuLotInfoList.length > 0 && cacheLotInfor.isHitCache) {
            //     tempSkuLotInfor = currentSkuLotInformation.concat(cacheLotInfor.f1SkuCacheModel.skuLotInfoList)
            // } else {
            //     tempSkuLotInfor = currentSkuLotInformation;
            // }
            tempSkuLotInfor = currentSkuLotInformation;
            this.addSelectedLotCache(tempSkuLotInfor);
        } else {
            let selectedLotsInfor = JSON.parse(
                localStorage.getItem('SkuLotInformation'),
            );
            let currentSelectedLots = [];
            if (selectedLotsInfor.length > 0) {
                selectedLotsInfor.map((currentItem, currentIndex) => {
                    if (currentItem.cartId === this.state.currentCartId) {
                        currentSelectedLots = currentItem.skuLotInfos;
                        if (currentItem.skuLotInfos.length > 0) {
                            currentSelectedLots = currentItem.skuLotInfos;
                        } else {
                            //localStorage中没有
                            if (
                                cacheLotInfor.f1SkuCacheModel.skuLotInfoList
                                    .length > 0
                            ) {
                                if (cacheLotInfor.isHitCache) {
                                    if (
                                        this.getCurrentCheckedLots().length > 0
                                    ) {
                                        currentSelectedLots =
                                            cacheLotInfor.f1SkuCacheModel
                                                .skuLotInfoList;
                                    } else {
                                        currentSelectedLots = [];
                                    }
                                } else {
                                    if (selectedSkuLotReqs.length <= 0) {
                                        currentSelectedLots =
                                            cacheLotInfor.f1SkuCacheModel
                                                .skuLotInfoList;
                                    } else {
                                        currentSelectedLots = [];
                                    }
                                }
                            } else {
                                currentSelectedLots = [];
                            }
                        }
                        return currentSelectedLots;
                    }
                });
            }

            this.addSelectedLotCache(currentSelectedLots);
        }

        let selectedTOption = this.resetSelectSkuLotReqs();
        this.setState({
            currentCartId: 0,
            inventoryCheckAll: false,
            selectedSkuLotReqs: selectedTOption,
        });
    };

    getCurrentCheckedLots = () => {
        let currentSkuCheckedLots = [];
        this.state.skuInventoryData.length > 0 &&
            this.state.skuInventoryData.forEach(
                (inventorySkuItem, inventorySkuIndex) => {
                    if (inventorySkuItem.checked) {
                        currentSkuCheckedLots.push(inventorySkuItem);
                    }
                },
            );
        return currentSkuCheckedLots;
    };

    getCacheLotInfor = () => {
        let LotItemIfor = {};
        let {allSelectedLotList, currentSku} = this.state;
        allSelectedLotList.length > 0 &&
            allSelectedLotList.forEach((selectItem, selectIndex) => {
                if (selectItem.sku === currentSku) {
                    LotItemIfor = selectItem;
                }
            });
        return LotItemIfor;
    };

    addSelectedLotCache = (currentSkuLotInformation) => {
        let {currentSupplyId, currentSku, selectedSkuLotReqs, currentCartId} =
            this.state;
        let currentSelectedLotReqs = [];
        selectedSkuLotReqs.length > 0 &&
            selectedSkuLotReqs.forEach((item, index) => {
                if (item.checked) {
                    currentSelectedLotReqs.push(item.key);
                }
            });
        let params = {
            supplyCenterId: currentSupplyId,
            sku: currentSku,
            skuLotReqs: currentSelectedLotReqs,
            skuLotInfoList: currentSkuLotInformation,
        };
        this.props.addSelectedLotCache(params).then((res) => {
            if (res && res.status === 'success') {
                let selectedLotsInfor = JSON.parse(
                    localStorage.getItem('SkuLotInformation'),
                );
                selectedLotsInfor.length > 0 &&
                    selectedLotsInfor.forEach((lotInforItem, lotInforIndex) => {
                        if (lotInforItem.cartId === currentCartId) {
                            lotInforItem.skuLotInfos = currentSkuLotInformation;
                            lotInforItem.skuLotReqs = currentSelectedLotReqs;
                        }
                    });

                localStorage.setItem(
                    'SkuLotInformation',
                    JSON.stringify(selectedLotsInfor),
                );

                this.setState({
                    confirmBtn: false,
                });
                this.getF1Cart();
                this.props.openNotification(
                    T('fone_order_selected_lot_add_success'),
                    'danger',
                );
            }
        });
    };

    resetSelectSkuLotReqs = () => {
        let selectedTOption = this.state.selectedSkuLotReqs;
        selectedTOption.forEach((selectedItem, selectedIndex) => {
            selectedItem.checked = false;
        });
        return selectedTOption;
    };

    getCurrentSkuItem = (
        currentSelectedInventorySku,
        currentSkuLotInformation,
    ) => {
        currentSelectedInventorySku &&
            currentSelectedInventorySku.forEach((item, i) => {
                let currrentItem = {};
                if (item.type === 'LSC') {
                    currrentItem = {
                        id: item.id,
                        sku: item.sku,
                        branch: item.branch,
                        branchDesc: item.branchDesc,
                        ddnsaDate: item.ddnsaDate,
                        dnsaDate: item.dnsaDate,
                        location: item.location,
                        lot: item.lot,
                        lotExpirationDate: item.lotExpirationDate,
                        availableInventory: item.availableInventory,
                        availableQuantity: item.availableQuantity,
                        type: item.type,
                    };
                } else {
                    currrentItem = {
                        id: item.id,
                        sku: item.sku,
                        branch: item.branch,
                        branchDesc: item.branchDesc,
                        ddnsaDate: item.ddnsaDate,
                        dnsaDate: item.dnsaDate,
                        location: item.location,
                        lot: item.lot,
                        lotExpirationDate: item.lotExpirationDate,
                        availableInventory: item.availableInventory,
                        availableQuantity: item.availableQuantity,
                        type: item.type,
                    };
                }
                currentSkuLotInformation.push(currrentItem);
            });
    };

    controlInventoryCheck = (
        skuInventoryDetails,
        isInitId,
        isAllCheckedFlag,
    ) => {
        if (skuInventoryDetails.length > 0) {
            for (let n = 0; n < skuInventoryDetails.length; n++) {
                if (typeof isAllCheckedFlag !== 'undefined') {
                    skuInventoryDetails[n]['checked'] = true;
                } else {
                    skuInventoryDetails[n]['checked'] = false;
                }
                if (isInitId) {
                    skuInventoryDetails[n]['id'] = n + 1;
                }
            }
        }
    };

    handleChange = (title, value) => {
        this.setState({
            comments: value,
        });
    };

    getCurrentCartSelectedLotInfor = (currentF1CartInfor) => {
        let {allSelectedLotList} = this.state;
        let currentF1CartSelectedLotInfor = {};
        allSelectedLotList.length > 0 &&
            allSelectedLotList.forEach((lotItem, lotIndex) => {
                if (lotItem.sku === currentF1CartInfor.sku) {
                    currentF1CartSelectedLotInfor = lotItem;
                }
            });
        return currentF1CartSelectedLotInfor;
    };

    render() {
        const {
            listLoaded,
            checkAll,
            defaultCheck,
            deleteItemDialogOpened,
            pageLoading,
            inventoryDetailsLoading,
            inventoryDetailsOpened,
            inventoryCheckAll,
            skuInventoryData,
            selectedSkuLotReqs,
            confirmBtn,
            allSelectedLotList,
            submitSkuToF1CartMassage,
            submitSkuToF1CartDialogOpened,
        } = this.state;
        const {f1CartList, localData} = this.props;
        this.disableOverFlow(pageLoading);
        let lang = loadLanguage();

        console.log(selectedSkuLotReqs, '------selectedSkuLotReqs');
        return (
            <div className="replenishment-cart">
                <div className="container-max-width is-fixed background"></div>
                <div className="container-max-width is-fixed background-cover"></div>

                {pageLoading ? (
                    <div className="checkout-loading-mask">
                        <LoadingIcon className="circle-animation" />
                    </div>
                ) : null}

                <Header
                    increment={0}
                    hasUserCenter={true}
                    hasArrowBackIos={true}
                    backEvent={this.goBack}>
                    <Grid
                        className="page-title-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid className="page-title" item xs={12}>
                            <span>{T('fone_order_shopping_cart')}</span>
                        </Grid>
                    </Grid>

                    <Grid
                        className="supply-center-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid
                            className="supply-center-title text-ellipsis"
                            item
                            xs={12}>
                            <span>
                                {T('fone_order_current_is')}{' '}
                                {localData.defaultScName}
                            </span>
                        </Grid>
                    </Grid>
                </Header>
                {/* <Grid className='replenishment-cart-add-card'>
                    <BasicInput 
                        placeholder={T('backup_please_input_sku')}
                        inputValid={this.handleChangeNum}
                        type="text"
                        value={productNum}
                    />
                    <span className='replenishment-cart-add-card-btn' onClick={this.addCart}>{T('addToShoppingCart')}</span>
                </Grid> */}
                {listLoaded ? (
                    <LoadingIcon className="circle-animation" />
                ) : (
                    <Grid
                        className="replenishment-cart-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        {allSelectedLotList.length > 0 &&
                            f1CartList &&
                            f1CartList.map((item, i) => {
                                return (
                                    <Grid
                                        className="replenishment-cart-list"
                                        key={item.productId}
                                        item
                                        xs={11}>
                                        <F1ShoppingCart
                                            f1CartInfo={item}
                                            f1CartSelectedLotsInfor={this.getCurrentCartSelectedLotInfor(
                                                item,
                                            )}
                                            changeNum={this.changeNum}
                                            handleCheck={this.handleSingleCheck}
                                            defaultCheck={defaultCheck}
                                            inventoryDetails={
                                                this.inventoryDetails
                                            }
                                            deleteF1Item={this.chooseItem}
                                        />
                                    </Grid>
                                );
                            })}
                    </Grid>
                )}
                <div
                    style={{
                        position: 'fixed',
                        bottom: '5.15rem',
                        left: '50%',
                        width: '100%',
                        maxWidth: 440,
                        transform: 'translateX(-50%)',
                        background: '#fff',
                    }}>
                    <BasicTextArea
                        style={{
                            width: '100%',
                            borderRadius: 0,
                            borderLeft: 0,
                            borderRight: 0,
                        }}
                        type="text"
                        title=""
                        maxlength="200"
                        placeholder={T('fone_order_enter_comments')}
                        inputValid={this.handleChange}
                    />
                </div>
                <Grid
                    className="page-bottom-container container-max-width f1-replenishment-grid is-fixed no-margin"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid className="all-selected" item xs={2}>
                        <Checkbox
                            checked={checkAll}
                            onChange={this.handleCheck}
                        />
                        <span className="all-selected-title">
                            {T('fone_order_select_all')}
                        </span>
                    </Grid>

                    <Grid item className="batch-deletion" xs={6}>
                        <BasicButton
                            type="primary"
                            disabled={false}
                            onClickOfSingleTap={this.batchDeletion}>
                            <span>
                                {T('product_management_batch_deletion')}
                            </span>
                        </BasicButton>
                    </Grid>

                    <Grid
                        className={util.getClassName({
                            'add-cart-button': true && lang !== 'EN',
                            'en-add-cart-button': true && lang === 'EN',
                        })}
                        item
                        xs={4}>
                        <BasicButton
                            type="primary"
                            disabled={false}
                            onClickOfSingleTap={this.replenish}>
                            <span>{T('fone_order_replenishment')}</span>
                        </BasicButton>
                    </Grid>
                </Grid>

                <Dialog
                    opened={deleteItemDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('deleteItemDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="delete-shopping-cart-item-dialog">
                        <h5>{T('fone_order_confirm_delete')}</h5>
                        <p>{T('fone_order_confirm_delete_message')}</p>
                        <BasicButton
                            className="confirm-btn"
                            type="primary"
                            onClickOfSingleTap={() =>
                                this.deleteF1Item(this.state.selectedItem)
                            }>
                            {T('fone_order_confirm')}
                        </BasicButton>
                    </div>
                </Dialog>

                {inventoryDetailsLoading ? (
                    <div className="checkout-loading-mask">
                        <LoadingIcon className="circle-animation" />
                    </div>
                ) : (
                    <Dialog
                        opened={inventoryDetailsOpened}
                        dialogDidClose={() =>
                            this.dialogDidClose('inventoryDetailsOpened')
                        }
                        options={{bgClickClose: true}}>
                        <div className="f1-sku-inventory-dialog">
                            <div className="invertory-allcheck">
                                <div className="company-stock">
                                    {T('company_stock')}
                                </div>
                                {skuInventoryData &&
                                util.isArray(skuInventoryData) &&
                                skuInventoryData.length > 0 ? (
                                    <div className="checkbox">
                                        <Checkbox
                                            checked={inventoryCheckAll}
                                            onChange={this.handleInventoryCheck}
                                        />
                                    </div>
                                ) : null}
                            </div>
                            {skuInventoryData &&
                            util.isArray(skuInventoryData) &&
                            skuInventoryData.length > 0 ? (
                                <ul
                                    className="f1-sku-inventory-list"
                                    id="skuInventoryUl">
                                    {skuInventoryData.map((item, index) => (
                                        <li
                                            key={'sku-inventory-' + index}
                                            className="sku-inventory-li">
                                            <div className="sku-inventory">
                                                <Grid
                                                    className="sku-inventory-detail no-margin"
                                                    container
                                                    spacing={0}
                                                    justify={'space-evenly'}>
                                                    <Grid
                                                        className="sku-content-grid"
                                                        item
                                                        xs={12}>
                                                        <p className="sku-content">
                                                            <label>
                                                                {T('sku')}：
                                                            </label>
                                                            {item.sku}
                                                        </p>
                                                    </Grid>
                                                    <Grid
                                                        className="sku-content-grid"
                                                        item
                                                        xs={6}>
                                                        <p className="sku-content">
                                                            <label>
                                                                {T('warehouse')}
                                                            </label>
                                                            {item.branchDesc}
                                                        </p>
                                                    </Grid>
                                                    <Grid
                                                        className="sku-content-grid"
                                                        item
                                                        xs={6}>
                                                        <p className="sku-content">
                                                            <label>
                                                                {T(
                                                                    'available_quantity',
                                                                )}
                                                            </label>
                                                            {
                                                                item.availableInventory
                                                            }
                                                        </p>
                                                    </Grid>
                                                    {item.type === 'LSC' &&
                                                    !item.lot ? null : (
                                                        <Grid
                                                            className="sku-content-grid"
                                                            item
                                                            xs={6}>
                                                            <p className="sku-content">
                                                                <label>
                                                                    {T(
                                                                        'host_abnormal_lot_nubmer_colon',
                                                                    )}
                                                                </label>
                                                                {item.lot}
                                                            </p>
                                                        </Grid>
                                                    )}
                                                    {item.type === 'LSC' &&
                                                    !item.lotExpirationDate ? null : (
                                                        <Grid
                                                            className="sku-content-grid"
                                                            item
                                                            xs={6}>
                                                            <p className="sku-content">
                                                                <label>
                                                                    {T(
                                                                        'host_abnormal_expire_date_colon',
                                                                    )}
                                                                </label>
                                                                {
                                                                    item.lotExpirationDate
                                                                }
                                                            </p>
                                                        </Grid>
                                                    )}
                                                    {item.type === 'LSC' &&
                                                    !item.ddnsaDate ? null : (
                                                        <Grid
                                                            className="sku-content-grid"
                                                            item
                                                            xs={12}>
                                                            <p className="sku-content">
                                                                <label>
                                                                    {T(
                                                                        'ddnsaDate',
                                                                    )}
                                                                </label>
                                                                {item.ddnsaDate}
                                                            </p>
                                                        </Grid>
                                                    )}
                                                    {item.type === 'LSC' &&
                                                    !item.dnsaDate ? null : (
                                                        <Grid
                                                            className="sku-content-grid"
                                                            item
                                                            xs={12}>
                                                            <p className="sku-content">
                                                                <label>
                                                                    {T(
                                                                        'dnsaDate',
                                                                    )}
                                                                </label>
                                                                {item.dnsaDate}
                                                            </p>
                                                        </Grid>
                                                    )}
                                                </Grid>
                                            </div>
                                            <div className="checkbox sku-inventory-check">
                                                <Checkbox
                                                    checked={item.checked}
                                                    onChange={this.inventorySingleHandleCheck.bind(
                                                        this,
                                                        item,
                                                    )}
                                                />
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p className="no-sku-content">
                                    {T('get_inventory_details_error1')}
                                </p>
                            )}

                            {selectedSkuLotReqs &&
                            selectedSkuLotReqs.length > 0 ? (
                                <div className="time-options-container">
                                    {selectedSkuLotReqs.map(
                                        (timeRangeItem, timeRangeIndex) => (
                                            <div
                                                className="time-option"
                                                key={timeRangeIndex}>
                                                <Checkbox
                                                    checked={
                                                        timeRangeItem.checked
                                                    }
                                                    onChange={this.timeRangeSingleHandleCheck.bind(
                                                        this,
                                                        timeRangeItem,
                                                    )}
                                                />
                                                {timeRangeItem.value}
                                            </div>
                                        ),
                                    )}
                                </div>
                            ) : null}

                            <BasicButton
                                className="confirm-btn"
                                type="primary"
                                disabled={confirmBtn}
                                onClickOfSingleTap={() =>
                                    this.dialogDidInventoryClose(
                                        'inventoryDetailsOpened',
                                    )
                                }>
                                {T('shippment_confirm')}
                            </BasicButton>
                        </div>
                    </Dialog>
                )}

                <Dialog
                    opened={submitSkuToF1CartDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('submitSkuToF1CartDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="confirm-cancel-F1-order-dialog">
                        <h5>{T('fone_order_query_by_sku')}</h5>
                        <p>
                            {/* {submitSkuToF1CartMassage} */}
                            {typeof submitSkuToF1CartMassage !== 'undefined' &&
                                submitSkuToF1CartMassage.length > 0 &&
                                submitSkuToF1CartMassage.map((message) => (
                                    <div className="batch-black-sku">
                                        {message.sku}{' '}
                                        {T('black_list_sku_reason')}:{' '}
                                        {message.reason}
                                    </div>
                                ))}
                        </p>
                        <BasicButton
                            className="confirm-btn"
                            type="primary"
                            onClickOfSingleTap={() =>
                                this.dialogDidClose(
                                    'submitSkuToF1CartDialogOpened',
                                )
                            }>
                            {T('getInfo')}
                        </BasicButton>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {replenishment, localData} = state;
    return {
        localData: localData,
        f1CartList: replenishment.f1CartList,
        f1CartSelectedLotList: replenishment.f1CartSelectedLotList,
        skuInventoryDetails: replenishment.skuInventoryDetails,
        timeRangeOptions: replenishment.timeRangeOptions,
        f1CartCount: replenishment.f1CartCount,
    };
};

const mapDispatchToProps = {
    getSCInventroyDetails,
    getF1CartCount,
    AddF1Product,
    BatchAddF1Product,
    QueryF1Cart,
    getF1CartSelectedLotList,
    DeleteF1Cart,
    submitF1Order,
    sumbitF1Quantity,
    openNotification,
    setAdminData,
    setUserData,
    getInventoryDetails,
    getSysDict,
    addSelectedLotCache,
    // checkSku,
    // pushAddCart
};

export default connect(mapStateToProps, mapDispatchToProps)(ReplenishmentCart);
